import { Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { initials, NOTIFY_PAYERS_LABEL, payerRoleLabel, type OrgPayer } from "@/lib/account-resolve";
import { cn } from "@/lib/utils";

export interface AccountPayersBoxProps {
  payers: OrgPayer[];
  loading: boolean;
  title?: string;
  className?: string;
}

export function AccountPayersBox({ payers, loading, title = "Pueden resolverlo", className }: AccountPayersBoxProps) {
  return (
    <div className={cn("space-y-2 rounded-xl border border-border bg-muted/30 p-4 text-left", className)} data-testid="account-payers">
      <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{title}</p>
      {loading ? (
        <p className="text-sm text-muted-foreground">Cargando...</p>
      ) : payers.length === 0 ? (
        <p className="text-sm text-muted-foreground">Un administrador o supervisor de la cuenta.</p>
      ) : (
        <ul className="space-y-2">
          {payers.map((payer, index) => (
            <li key={`${payer.email ?? payer.name}-${index}`} className="flex items-center gap-3">
              <span
                aria-hidden="true"
                className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary/10 text-xs font-semibold text-primary"
              >
                {initials(payer.name)}
              </span>
              <span className="min-w-0">
                <span className="block truncate text-sm font-medium">{payer.name}</span>
                <span className="block text-xs text-muted-foreground">{payerRoleLabel(payer)}</span>
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export interface NotifyPayersButtonProps {
  href: string;
  className?: string;
}

export function NotifyPayersButton({ href, className }: NotifyPayersButtonProps) {
  return (
    <Button asChild className={cn("gap-1.5", className)}>
      <a href={href} data-testid="notify-payers">
        <Mail className="h-4 w-4" aria-hidden="true" /> {NOTIFY_PAYERS_LABEL}
      </a>
    </Button>
  );
}
